

const ResourceCheckbox = (props: any) =>
{
  const resource = props.resource;
  const toggleResource = props.toggleResource;
  const checked = props.checked; 
  
  const handleChange = () => {
    toggleResource(resource, checked)
  }; 
  
  return ( 
    <div>
      <input
        type="checkbox"
        className="form-check-input"
        checked={checked}
        onChange={handleChange} 
        />
    </div>
  ); 
}

export default ResourceCheckbox;